import axios from "axios";

export default axios.create({

    baseURL: process.env.NODE_ENV === "development" ? "https://overlander.com.hk/api/crm/" : "/api/crm/",
    //baseURL: "https://overlander-crm-progress.legato-concept.com/cms/api/v1/",
    withCredentials: true,
});

